<template>
  <div class="reset-password">
    <el-col :xs="{span: 20, offset: 1}" :sm="{span: 12, offset:6}">

      <div class="panelheader">
        <div class="title">Reset your password</div>
      </div>

      <div class="body">
        <el-form :model="password" :rules="rules" ref="resetForm" v-loading="formLoading">
          <el-form-item prop="code" class="codeInput">
            <el-input v-model="password.code" placeholder="Reset Code"></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input type="password" v-model="password.pass" placeholder="New password"></el-input>
          </el-form-item>
          <el-form-item prop="pass2">
            <el-input type="password" v-model="password.pass2" placeholder="Confirm password"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="save" @click="submitForm('resetForm')">Reset password</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </div>
</template>

<script>

import requests from '../requests';

export default {
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else if (!value.match(/[a-z]+/) || !value.match(/[A-Z]+/) || !value.match(/[0-9]+/) ) {
        callback(new Error('Passwords must contain at least one upper case, one lower case letter, and one number.'))
      } else if (value.length < 6) {
        callback(new Error('Password must be more than 6 characters'));
      } else {
        if (this.checkPass !== '') {
          this.$refs['resetForm'].validateField('pass2');
        }
      }
      callback();
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.password.pass) {
        callback(new Error('Two inputs don\'t match!'));
      }

      callback();
    };

    return {
      code: null,
      formLoading: false,
      password: {
        code: null,
        pass: '',
        pass2: '',
      },
      rules: {
        code: [
          { validator: this.validateCode, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass }
        ],
        pass2: [
          { validator: validatePass2 }
        ],
      }
    }
  },
  beforeMount() {
    this.code = this.$route.query.code;
    var context = this;

    if(this.code){
      this.password.code = this.code;
    }

  },
  methods: {
    submitForm(form) {
      if(form instanceof Event) {
        form.preventDefault();
        form = 'fpForm';
      }

      this.formLoading = true;

      this.$refs[form].validate( (valid) => {
        this.formLoading = false;

        if(!valid) {
          return false;
        }

        var context = this;

        requests.resetPassword(this, this.password, function(result) {
          console.log(result);
          if(result.action == 'success') {
            context.$message({
              type: 'success',
              message: 'Successfully updated your password.',
              showClose: true,
            });
            context.$router.push('/login');
          } else {
            context.$message({
              type: 'error',
              message: (<p>
                          <h3>Issue resetting your password.</h3>
                          <div>Please try again, or contact support</div>
                        </p>),
              showClose: true,
            })
          }
        });

      })
    },
    validateCode(rule, value, callback) {
      if(value) {
        requests.checkFPCode(this, value, function(result) {
          console.log(result);
          if(result.action == 'success' && result.data) {
            callback()
          } else {
            callback(new Error('Invalid or expired code.'));
          }
        });
      } else {
        callback(new Error('This field is required.'));
      }
    }
  }
}
</script>

<style>
  .codeInput {
    margin: 20px auto;
  }

  .body {
    background: white;
    padding: 8px;
  }
</style>



// WEBPACK FOOTER //
// ResetPassword.vue?7628db5f